import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { CustomThemeProvider } from './contexts/ThemeContext';
import { SyncProvider } from './contexts/SyncContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
// import Register from './pages/Register';
import AllAccounts from './pages/AllAccounts';
import VirtualBankAccounts from './pages/VirtualBankAccounts';
import PaymentSimulation from './pages/PaymentSimulation';
import Profile from './pages/Profile';

function App() {
  return (
    <CustomThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <SyncProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              {/* <Route path="/register" element={<Register />} /> */}

              {/* Protected routes */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/virtual-bank-accounts" replace />} />
                <Route path="virtual-bank-accounts" element={<VirtualBankAccounts />} />
                <Route path="all-accounts" element={<AllAccounts />} />
                <Route path="payment-simulation" element={<PaymentSimulation />} />
                <Route path="profile" element={<Profile />} />
              </Route>

              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/virtual-bank-accounts" replace />} />
            </Routes>
          </Router>
        </SyncProvider>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;